import { Injectable } from "@angular/core";

import { storageSignalTree } from "../../functions/storage-signal-tree.function";
import { migrateLegacyKeys } from "../../functions/migrate-legacy-keys.function";
import { IAppStorage } from "../../interfaces/app-storage-tree.interface";


@Injectable({
    providedIn: 'root'
})
export class AppLocalStorageService {
    // Geconsolideerde, persistente user-boom. Géén TTL: voorkeuren (theme/taal) en
    // navigation-history mogen niet dagelijks verlopen; cache-veroudering loopt via
    // geversioneerde keys (i18n) en backend-hydratie. Blijft staan na logout zodat
    // het login-scherm zich met de vorige user-boom vult.
    appData$$ = storageSignalTree<IAppStorage>(
        'app',
        {} as IAppStorage,
        {
            type: 'local',
            debounce: 300,
        }
    );

    constructor() {
        // Eénmalig de oude losse localStorage-keys de boom in migreren (idempotent).
        migrateLegacyKeys(this.appData$$);
    }
}
